<template>
  <v-container>
    <v-form ref="cardForm" v-model="valid">
      <v-file-input
        :multiple="multiple"
        @change="onUpload"
        :id="'filesUpload'+idCard"
        :rules="[requiredValidation]"
        :loading="isloading"
      >
       </v-file-input>
      <v-row dense >
        <v-img
          v-if="!multiple"
          :src="imagesUrls[0]"
        >
          <slot />
        </v-img>
        <v-carousel width="100%" v-else-if="imagesUrls.length>0" :key="carouselKey">
          <v-carousel-item
            v-for="(item,i) in imagesUrls"
            :key="i"
            :src="item"
            reverse-transition="fade-transition"
            transition="fade-transition"
          >
            <v-btn
              color="black"
              text
              :ripple="false"
              id="no-background-hover"
              @click="removeImage(i)"
            >
              <v-icon>
                mdi-close-circle
              </v-icon>
            </v-btn>
            <slot />
          </v-carousel-item>
        </v-carousel>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  props:{
    idCard:{
      type:String,
      default:''
    },
    cardTitle: {
      type: String,
      default: ''
    },
    multiple:{
      type:Boolean,
      default:true
    },
    preRegisteredValues: {
      type:Object
    }
  },
  data(){
    return {
      valid: false,
      newImages:[],
      preloadedImages:[],
      imagesToBase64Array:[],
      isloading:false,
      requiredRule: [
        v => (!!v||this.images.length==0) || 'Este campo es obligatorio.'
      ],
      carouselKey:0,
      isEditing: false
    }
  },
  beforeMount() {
    if(this.preRegisteredValues!==undefined){
      this.isEditing=true;
      this.preloadedImages.splice(0, this.preloadedImages.length, ...this.preRegisteredValues.imageSlide.map(el=> ({imageId:el,imageUrl: process.env.VUE_APP_CF_API_URL + '/api/projects/images/'+ el })))
    }
  },
  computed:{
    cardColumns:{
      get(){
        return (this.multiple)? 3:12
      }
    },
    imagesUrls:{
      get(){
        let imagesSrc = []
        if(this.preloadedImages.length> 0){
          imagesSrc.splice(0,0,...this.preloadedImages.map(el=> el.imageUrl))
        }
        if(this.newImages.length> 0){
          if(this.multiple)
            imagesSrc.splice(imagesSrc.length,0,...this.newImages.map(el=> el.imageUrl))
          else 
            imagesSrc.splice(0,1,this.newImages[0].imageUrl)
        }
        console.log('imagesSrc', imagesSrc)
        return imagesSrc
      }
    }
  },
  methods:{
    abtostring(str){
      var buf = new ArrayBuffer(str.length); 
      var bufView = new Uint8Array(buf);
      for (var i=0, strLen=str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
      }
      return buf;
    },
    requiredValidation(){
      return (this.newImages.length>0 || this.preloadedImages.length>0)? true:(this.multiple)?'Debe adjuntar al menos una imagen.':'Debe adjuntar una imagen.'
    },
    onUpload(value){
      if(! (value.length==0 || value.size==0) && value!==this.newImages.map(el=> el.imageFile)){
        this.isloading=true
        if(this.multiple){
          this.newImages.splice(this.newImages.length,0, ...value.map(el=> ({imageId:undefined, imageFile:el, imageUrl:URL.createObjectURL(el) })))
        } else {
          this.newImages.splice(0, 1, {imageId:undefined, imageFile:value,imageUrl:URL.createObjectURL(value) })
        }
        var promises = []
        for(var i = 0; i < this.newImages.length; i ++) {
          promises.push(this.createImage(this.newImages[i].imageUrl, i));
        }
        Promise.all(promises).then(()=>{
          this.isloading = false
          if(this.newImages.length + this.preloadedImages.length >0){
            this.$emit('isValid',this.idCard,true)
            this.emitCardInfo()
          }else
            this.$emit('isValid',this.idCard,false)
        }) 
      }
    },
    emitCardInfo(){
      this.$refs.cardForm.validate()
      if(!this.valid && this.preRegisteredValues.imageSlide.length > 0){
        this.valid = true
      }
      if(this.valid){
        var event = 'getCardInfo'
        var card= {
          name: this.cardTitle,
          cardType: (this.multiple)?1:0,
        }
        if(this.multiple){
          card.imageSlide= []
          card.oldImageSlide= []
          if(this.isEditing){
            card.oldImageSlide.splice(0, 0, ...this.preloadedImages.map(el=>el.imageId))
          }
          card.imageSlide.splice(card.imageSlide.length, 0, ...this.imagesToBase64Array)
        } else {
          card.imageId = undefined
          if(this.newImages.length>0)
            card.imageId=this.imagesToBase64Array[0]
          else
            card.imageId=this.preloadedImages[0].imageId
        }
        if(this.isEditing)
          card.projectCardId= this.preRegisteredValues.projectCardId  
        this.$emit(event, card)
      }
    },
    removeImage(index) {
      if(index> this.preloadedImages.length){
        let newIndex= index - this.preloadedImages.length
        this.newImages.splice(newIndex,1)
        this.imagesToBase64Array.splice(newIndex,1);
      } else {
        this.preloadedImages.splice(index, 1);
      }  
    },
    createImage(imageFile, index) {
      return new Promise(function(resolve){
        const image = document.createElement('img');
        image.setAttribute('src', imageFile);
        image.onload = () => this.convertImage(image,index).then(()=> resolve());
      }.bind(this)).catch(e=> console.log('error: ',e))
    },
    convertImage(image,index) {
      return new Promise(function(resolve){
        const canvas = this.drawImageToCanvas(image);
        this.imagesToBase64Array[index]=canvas.toDataURL().split(',')[1]
        resolve()
      }.bind(this))
    },
    drawImageToCanvas(image) {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      canvas.getContext('2d').drawImage(image, 0, 0, image.width, image.height);
      return canvas;
    },
    base64ArrayBuffer(arrayBuffer) {
      var base64    = ''
      var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

      var bytes         = new Uint8Array(arrayBuffer)
      var byteLength    = bytes.byteLength
      var byteRemainder = byteLength % 3
      var mainLength    = byteLength - byteRemainder

      var a, b, c, d
      var chunk

      // Main loop deals with bytes in chunks of 3
      for (var i = 0; i < mainLength; i = i + 3) {
        // Combine the three bytes into a single integer
        chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

        // Use bitmasks to extract 6-bit segments from the triplet
        a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
        b = (chunk & 258048)   >> 12 // 258048   = (2^6 - 1) << 12
        c = (chunk & 4032)     >>  6 // 4032     = (2^6 - 1) << 6
        d = chunk & 63               // 63       = 2^6 - 1

        // Convert the raw binary segments to the appropriate ASCII encoding
        base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
      }

      // Deal with the remaining bytes and padding
      if (byteRemainder == 1) {
        chunk = bytes[mainLength]

        a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

        // Set the 4 least significant bits to zero
        b = (chunk & 3)   << 4 // 3   = 2^2 - 1

        base64 += encodings[a] + encodings[b] + '=='
      } else if (byteRemainder == 2) {
        chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

        a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
        b = (chunk & 1008)  >>  4 // 1008  = (2^6 - 1) << 4

        // Set the 2 least significant bits to zero
        c = (chunk & 15)    <<  2 // 15    = 2^4 - 1

        base64 += encodings[a] + encodings[b] + encodings[c] + '='
      }
      
      return base64
    }
  }

}
</script>

<style scoped lang="scss">
#no-background-hover::before {
   background-color: transparent !important;
}
</style>